import { AbstractIdbaModel } from "../abstract-idba-model";


export class RelacaoGenerica extends AbstractIdbaModel {

  public override convertToModel(data: any): AbstractIdbaModel {
    return new RelacaoGenerica(data);
  }

  public override display(self: any): string {
    return self && self.codigo!=null && self.codigo!=undefined ? `${self.codigo} - ${self.valor}` : '';
  }
  public override displayCodigo(self: any): string {
    throw new Error("Method not implemented.");
  }
  public override displayNome(self: any): string {
    throw new Error("Method not implemented.");
  }
  public override filter(value: string, objectList: any[]): any[] {
    const filterValue = value.toLowerCase();
    return objectList.filter(
      (item) =>
        item.valor.trim().toLowerCase().includes(filterValue) ||
        item.codigo.toString().toLowerCase().includes(filterValue)
    );
  }

  idEmpresa: number
  idFilial: number
  idLocal: number
  assunto: string
  codigo: string
  valor: string

}
